import { PropsWithChildren, ReactElement } from 'react';

import AuthorLayoutSidebar from 'components/AuthorLayoutSidebar';

type Props = {
  title: string;
};

function AuthorLayout(
  props: PropsWithChildren<Props>
): ReactElement<HTMLDivElement> {
  return (
    <div className="py-10 min-h-screen bg-gray-100">
      <div className="mx-auto max-w-5xl flex flex-row">
        <AuthorLayoutSidebar />
        <div className="p-10 rounded-xl flex-grow bg-white">
          <div className="mb-10 text-primary font-display">
            <h1 className="text-3xl">{props.title}</h1>
          </div>
          {props.children}
        </div>
      </div>
    </div>
  );
}

export default AuthorLayout;
